import { useState, useEffect } from 'react';
import { InnocodePaymentCardInfo, InnocodePaymentListHorizental } from '@intsoft/innocode-payment';
import { InnocodeBadge, InnocodeButton, InnocodePaginationGroup, InnocodeTextButton, useDialog } from '@intsoft/innocode-core';
import { PaymentMethod, PaymentType, getPaymentTypeColor, getPaymentTypeLabel } from '../../../resources/utils/paymentUtils';
import styles from './PaymentHistoryDetail.module.css';
import axios from "../../../utils/api/axios";
import { constants } from 'fs';
import { useParams } from 'react-router-dom';
import { STORE_ORDER, ZENPAY_BILLING, ZENPAY_PAYMENT } from '../../../utils/Config';
import moment from 'moment';


export interface paymentHistoryDetailInfo {
  paymentId: string;
  paymentDate: string;
  paymentAmount: number;
  paymentStatus: PaymentType;
  paymentTitle?: string;
  paymentDescription?: string;
  paymentEtc?: string;
  paymentThumbnailUrl?: string;
  paymentStoreName?: string;
  paymentStoreBadge?: string;
}

// value 배열에 들어갈 개별 할인 항목의 타입을 정의합니다.
interface DiscountDetail {
  discountAmount: number;
  discountName: string;
}

// discount 상태 객체 전체의 타입을 정의합니다.
interface DiscountInfo {
  discountRate: number;
  discountAmount: number;
  value: DiscountDetail[]; // value는 DiscountDetail 객체들의 배열입니다.
}

export default function Page() {
  const [platform, setPlatform] = useState<'web' | 'tablet-vertical' | 'mobile'>('web');
  const { showDialog } = useDialog();
  const [enableDeleteMode, setEnableDeleteMode] = useState(false);

  const { paymentId } = useParams();

  const [payment, setPayment] = useState<any>({});
  const [receipt, setReceipt] = useState<any>({});
  const [paymentType, setPaymentType] = useState<String>('');
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [discount, setDiscount] = useState<DiscountInfo>({
    discountRate: 0,
    discountAmount: 0,
    value: [] // 초기값도 타입에 맞게 설정합니다.
  });
  const [paymentHistoryList, setPaymentHistoryList] = useState<paymentHistoryDetailInfo[]>([
  ]);

  const toggleDeleteMode = () => {
    setEnableDeleteMode(!enableDeleteMode);
  };

  const getPlatform = (width: number): 'web' | 'tablet-vertical' | 'mobile' => {
    if (width < 768) return 'mobile';
    if (width < 1440) return 'tablet-vertical';
    return 'web';
  };


  useEffect(() => {
    // 초기 사이즈 설정 
    setPlatform(getPlatform(window.innerWidth));
    // 윈도우 리사이즈 이벤트 핸들러
    const handleResize = () => {
      setPlatform(getPlatform(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    // 클린업 함수
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  useEffect(() => {
    getPaymentHistoryList();
  }, []);

  const getPaymentHistoryList = async () => {
    try {

      const res = await axios.get(`${ZENPAY_PAYMENT}/get/${paymentId}`, {
        headers: {
          'Content-Type': 'application/json',
          'API-KEY': `zentapay`
        }
      });

      const paymentInfo = res.data.data.paymentInfo[0];

      console.log('paymentInfo', paymentInfo);

      const formattedDate = moment(paymentInfo.paymentPaidDate).format('YYYY-MM-DD HH:mm:ss');
      setReceipt(paymentInfo.receiptUrl);

      const conditions = [
        { field: "paymentId", operator: "EQUALS", value: paymentInfo.paymentId },
      ];
      const params = {
        page: 0,
        size: 0,
        sortField: ['createdDate'],
        sortOrder: ['asc'],
        operator: "AND",
        conditions
      };

      const storeRes = await axios.post(`${STORE_ORDER}/all`, params);
      const orders = storeRes?.data?.data.data;

      const paymentHistoryList: paymentHistoryDetailInfo[] = Array.isArray(orders)
        ? orders.flatMap((order: any) => {
          const marketName = order.marketname;
          const orderInfo = order.orderInfo;
          setOrderInfo(orderInfo ? orderInfo : {});

          const marketplaceInfo = order.marketplaceInfo;

          if (!Array.isArray(marketplaceInfo)) {
            return [];
          }

          return marketplaceInfo.map((item: any) => {
            const description = `${item.quanity}개 / ` + (Array.isArray(item.option)
              ? item.option.map((opt: any) => opt.optionName).join(' / ')
              : ''); // 옵션이 배열이 아닐 경우를 대비

            return {
              // 주문 공통 정보
              paymentId: orderInfo.paymentId + item.marketplaceId,
              paymentDate: formattedDate,
              paymentStatus: orderInfo.orderStatus,
              paymentStoreName: marketName,

              // === 상품 개별 정보 ===
              paymentTitle: item.item_name,
              paymentThumbnailUrl: item.imageUrl ? item.imageUrl : undefined,
              paymentAmount: item.price, // 상품 개당 가격
              paymentDescription: description, // 가공된 옵션 정보
            };
          });
        })
        : []; // orders가 배열이 아니면 최종 결과는 빈 배열 []이 됩니다.

      //json으로 만들어서 할인율 계산
      //만약 order item에 상품 할인 정보가 있다면 다 더해서 할인율 계산
      let totalDiscountAmount = 0;
      const discountDetails: { discountAmount: number, discountName: string }[] = [];

      // 모든 주문과 상품을 다시 순회하며 가격 및 할인 정보 집계
      if (Array.isArray(orders)) {
        orders.forEach((order: any) => {
          if (Array.isArray(order.marketplaceInfo)) {
            order.marketplaceInfo.forEach((item: any) => {
              // 할인 정보가 있는 경우에만 처리 (discountAmount가 0보다 클 때)
              item.discount.forEach((discount: any) => {
                const discountAmount = Number(discount.discountAmount || 0);
                if (discountAmount > 0) {
                  // 총 할인 금액 합산
                  totalDiscountAmount += discountAmount;
                  // 상세 할인 내역 배열에 추가
                  discountDetails.push({
                    discountAmount: discountAmount,
                    discountName: discount.discountName || '-알 수 없는 할인-'
                  });
                }
              })
            });
          }
        });
      }

      // 4. 최종 할인율 계산 (0으로 나누는 오류 방지)
      const discountRate = paymentInfo.totalAmount > 0
        ? Math.round((totalDiscountAmount / paymentInfo.totalAmount) * 100)
        : 0;

      // 5. 요구사항에 맞는 최종 JSON 객체 생성
      const discountInfoJson = {
        discountRate: discountRate,
        discountAmount: totalDiscountAmount,
        value: discountDetails
      };



      let paymentType = 'ZENTAPAY';

      const paymentMethod = paymentInfo.paymentMethod;
      console.log("결제 정보", paymentInfo.paymentInfo);


      if (paymentMethod === PaymentMethod.BILLING_KEY) {

        const billingKey = paymentInfo.paymentInfo.zenPayBillingKey;
        const billingKeyInfo = await axios.get(`${ZENPAY_BILLING}/get?billingKey=${billingKey}`);

        const billingKeyInfoData = billingKeyInfo.data.data;

        console.log('billingKeyInfoData', billingKeyInfoData);

        paymentType = `ZenPAY(${billingKeyInfoData.cardName})`;
      } else if (paymentMethod === PaymentMethod.CARD || paymentMethod === PaymentMethod.KEYIN) {
        paymentType = 'ZENTAPAY';
      } else if (paymentMethod === PaymentMethod.TRANSFER) {
        paymentType = 'ZENTAPAY';
      } else if (paymentMethod === PaymentMethod.VIRTUAL_ACCOUNT) {
        paymentType = 'ZENTAPAY';
      } else if (paymentMethod === PaymentMethod.MOBILE) {
        paymentType = '모바일';
      }

      setPaymentType(paymentType);
      setDiscount(discountInfoJson);
      setPayment(paymentInfo);
      setPaymentHistoryList(paymentHistoryList);


    } catch (error) {
      console.error(error);
    }
  }



  const deletePaymentHistory = () => {
    showDialog({
      type: 'delete',
      iconType: 'warning',
      title: '지금 보고 있는 결제 내역을 삭제하시겠어요?',
      message: '삭제 시, 해당 결제 내역은 영구 삭제돼\n다시 복원할 수 없습니다.',
      cancelText: '아니요',
      confirmText: '예',
      onConfirm: async () => {

        const res = await axios.delete(`${ZENPAY_PAYMENT}/delete-history/${paymentId}`, {
          headers: {
            'API-KEY': 'zentapay'
          }
        });

        if (res.data.code === 200) {
          showDialog({
            type: 'info',
            iconType: 'check',
            title: '선택 내역을 삭제했습니다.',
            confirmText: '완료',
            onConfirm: () => {
              window.history.back()
            }
          });
        } else {
          showDialog({
            type: 'info',
            iconType: 'check',
            title: '선택 내역을 삭제하지 못했습니다.',
            confirmText: '확인',
            onConfirm: () => {
              window.history.back()
            }
          });
        }
      }
    });
  }

  const handleReceiptView = () => {
    // receipt url로 이동
    window.open(receipt, '_blank');

  }

  return (
    <div className="content-wrapper">
      <div className={styles.pageWrapper}>
        <div className={styles.titleSection}>
          {(platform === "web") && (
            <InnocodeButton iconOnly={true} onClick={() => window.history.back()} designType='assistive' theme="opacity">
              <svg {...{ slot: "icon" }} className="w-6 h-6 text-gray-800 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
              </svg>
            </InnocodeButton>
          )}
          <h3 className="innocode-typography--headline-sm innocode-typography--bold">결제 상세 정보</h3>
        </div>
        <div className={styles.contentSection}>
          <div className={`${styles.paymentItemWrapper} ${styles.boxWrapper}`}>
            {platform === "web" && (
              <div className={styles.paymentItemAction}>
                <InnocodeTextButton type={"assistive"} onClick={deletePaymentHistory}>내역 삭제</InnocodeTextButton>
              </div>
            )}
            <div className={styles.paymentItemList}>
              {paymentHistoryList.map((paymentHistory) => (
                <InnocodePaymentListHorizental
                  key={paymentHistory.paymentId}
                  className="list_item"
                  size={platform == "web" ? "lg" : "md"}
                  status="default"
                  showTopContents={false}
                  leadingThumbnail={true}
                  thumbnailSrc={paymentHistory.paymentThumbnailUrl || 'https://picsum.photos/800/600'}
                  thumbnailAlt="썸네일 이미지"
                  showThumbnailBadge={discount.discountRate > 0 ? true : false}
                  thumbnailBadgeLabel={discount.discountRate > 0 ? `${discount.discountRate}%` : ''}
                  thumbnailSize={(platform === "web" || platform === "tablet-vertical") ? "md" : "sm"}
                  showStoreInfo={true}
                  showStoreName={true}
                  storeName={paymentHistory.paymentStoreName || ''}
                  showStoreBadge={true}
                  storeBadgeStyle={"opacity"}
                  storeBadgeLabel={paymentHistory.paymentStoreBadge || ''}
                  showTitle={true}
                  title={paymentHistory.paymentTitle || ''}
                  showDescription={true}
                  description={paymentHistory.paymentDescription || ''}
                  showBottomContents={true}
                  showAmount={true}
                  amount={paymentHistory.paymentAmount}
                  showPaymentDate={true}
                  paymentDate={`${paymentHistory.paymentDate} 결제`}
                  showButton={false}
                />
              ))}
            </div>

          </div>
          {orderInfo && Object.keys(orderInfo).length > 0 && (
            <div className={`${styles.informationWrapper} ${styles.boxWrapper}`} >
              <h3 className="innocode-typography--headline-md innocode-typography--bold">배송 정보</h3>
              <div className={styles.infoItemList}>
                <div className={styles.item}>
                  <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>수령인</p>
                  <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>홍길동</p>
                </div>
                <div className={styles.item}>
                  <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>휴대폰</p>
                  <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>010-1234-5678</p>
                </div>
                <div className={styles.item}>
                  <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>주소</p>
                  <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>[00000] 서울 서초구 주흥길 64 (방배동, 아너스빌) 2층 204호</p>
                </div>
              </div>
            </div>
          )}

          <div className={`${styles.informationWrapper} ${styles.boxWrapper}`} >
            <div className={`${styles.informationHeader}`}>
              <h3 className="innocode-typography--headline-md innocode-typography--bold">결제 상세 정보</h3>
              <InnocodeTextButton
                size={"sm"}
                type={"primary"}
                onClick={handleReceiptView}
              >영수증 보기</InnocodeTextButton>
            </div>

            <div className={styles.infoItemList}>
              <div className={styles.item}>
                <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>상품명</p>
                <div className={`${styles.valueWrapper} ${styles.mobileVertical}`}>
                  <p className={`${styles.valueInWrapper} innocode-typography--body-lg-normal innocode-typography--medium`}>{payment?.paymentInfo?.orderName || ''}</p>
                  {/* <p className={`${styles.valueInWrapperShrink} innocode-typography--body-lg-normal innocode-typography--medium`}>외 2건</p> */}
                </div>
              </div>
              <div className={styles.item}>
                <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제 번호</p>
                <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{payment?.paymentId || ''}</p>
              </div>
              <div className={styles.item}>
                <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제일</p>
                <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{moment(payment?.paymentPaidDate).format('YYYY.MM.DD HH:mm:ss') || ''}</p>
              </div>

              <div className={styles.item}>
                <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>할인 금액</p>
                <div className={styles.valueWrapper}>
                  {discount.discountRate > 0 ?
                    <>
                      <InnocodeBadge theme="opacity" type="primary" size="lg" className="discount-badge">{discount.discountRate}% 할인</InnocodeBadge>
                      <p className={`${styles.valueInWrapper} innocode-typography--body-lg-normal innocode-typography--medium`}>{discount.discountAmount}원</p>
                    </>
                    : <p className={`${styles.valueInWrapper} innocode-typography--body-lg-normal innocode-typography--medium`}>0원</p>
                  }
                </div>
              </div>

              {discount.value.length > 0 &&
                discount.value.map((item, index) => (
                  <div className={styles.item} key={index}>
                    <p className={`${styles.label} innocode-typography--body-sm-reading innocode-typography--medium ${styles.discountInfo}`}>↳ {item.discountName}</p>
                    <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{item.discountAmount}원</p>
                  </div>
                ))
              }

              <div className={styles.item}>
                <p className={`${styles.label} innocode-typography--body-lg-normal innocode-typography--medium`}>결제 수단</p>
                <p className={`${styles.value} innocode-typography--body-lg-normal innocode-typography--medium`}>{paymentType}</p>
              </div>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.totalAmountInfo}>
              <p className={`${styles.totalAmountLabel} innocode-typography--headline-xs innocode-typography--semibold`}>총 결제 금액</p>
              <p className={`${styles.totalAmountValue} innocode-typography--headline-sm innocode-typography--bold`}>{payment.totalAmount || 0}원</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}